
import { Test } from './Test'
import { LV3_Bill_List } from './lv3/Bill'

// 兼容非npm使用环境
let windowCopy = window as any
windowCopy.Test = Test
windowCopy.LV3_Bill_List = LV3_Bill_List

export {
  Test,
  LV3_Bill_List
}